import { useRef, forwardRef, useImperativeHandle } from "react";

// ________input value 날짜 형식으로 포맷__________
const DateInput = forwardRef(function DateInput(
  { setForm, value, htmlFor, readOnly = null },
  ref,
) {
  const pickerRef = useRef(null);
  const textInputRef = useRef(null);

  // ref를 통해 text input에 접근 가능하도록 설정
  useImperativeHandle(ref, () => textInputRef.current);

  const formatDate = (input) => {
    const cleaned = input.replace(/\D/g, "").slice(0, 8);

    if (cleaned.length < 5) return cleaned;
    if (cleaned.length < 7) return `${cleaned.slice(0, 4)}-${cleaned.slice(4)}`;
    return `${cleaned.slice(0, 4)}-${cleaned.slice(4, 6)}-${cleaned.slice(6)}`;
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [htmlFor]: formatDate(e.target.value) }));
  };

  const handlePickerChange = (e) => {
    setForm((prev) => ({ ...prev, [htmlFor]: e.target.value || "" }));
  };

  const openPicker = () => {
    const picker = pickerRef.current;
    if (!picker) return;

    if (typeof picker.showPicker === "function") {
      try {
        picker.showPicker();
      } catch (e) {
        picker.focus();
        picker.click();
      }
      return;
    }

    picker.focus();
    picker.click();
  };

  const isEditable = readOnly !== true;
  const hasFullDate = /^\d{4}-\d{2}-\d{2}$/.test(value ?? "");
  const inputClassName =
    `${readOnly !== null && !readOnly ? "active " : ""}dateInputField`.trim();

  return (
    <div className="dateInputWrap">
      <input
        ref={textInputRef}
        id={htmlFor}
        type="text"
        value={value ?? ""}
        onChange={handleChange}
        placeholder="YYYY-MM-DD"
        readOnly={readOnly === true}
        className={inputClassName}
      />

      {isEditable && (
        <>
          <button
            type="button"
            className="dateInputCalendarBtn"
            onClick={openPicker}
            aria-label={`${htmlFor} calendar`}
          >
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="17"
                rx="2"
                stroke="currentColor"
                strokeWidth="1.7"
              />
              <path
                d="M8 2.8V6.2M16 2.8V6.2M3 9H21"
                stroke="currentColor"
                strokeWidth="1.7"
              />
              <circle cx="12" cy="14" r="1.8" fill="currentColor" />
            </svg>
          </button>

          <input
            ref={pickerRef}
            type="date"
            className="dateInputPicker"
            value={hasFullDate ? value : ""}
            tabIndex={-1}
            aria-hidden="true"
            onChange={handlePickerChange}
          />
        </>
      )}
    </div>
  );
});

export default DateInput;
